// extracted by mini-css-extract-plugin
export default {"copyableText":"CopyableText__copyableText___gJ6MV"};